import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export const PlayIcon = (props: IconProps) => (
  <Icon viewBox="0 0 12 12" {...props}>
    <path
      d="M10.5938 6.56398C10.3581 7.45934 9.24449 8.09202 7.0172 9.35738C4.86407 10.5806 3.78751 11.1922 2.91993 10.9464C2.56124 10.8447 2.23443 10.6517 1.97087 10.3858C1.33337 9.7426 1.33337 8.49507 1.33337 6C1.33337 3.50493 1.33337 2.2574 1.97087 1.61421C2.23443 1.3483 2.56124 1.15526 2.91993 1.05361C3.78751 0.807766 4.86407 1.41938 7.0172 2.64262C9.24449 3.90798 10.3581 4.54066 10.5938 5.43602C10.691 5.80559 10.691 6.19441 10.5938 6.56398Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </Icon>
);
